import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Area } from '../constants/area';

export interface DivisionResponse {
  id: number;
  divisionName: string;
  createdByUserId: number;
  createdDate: string;
  lastModifiedByUserId: number;
  lastModifiedDate: string;
  isActive: boolean;
}

@Injectable()
export class DivisionService {
  constructor(private httpClient: HttpClient) { }

  public getActiveDivisions() {
    const url = `${environment.dotNetApiUrl}/${Area.core}/Division/Active`;
    return this.httpClient.get<DivisionResponse[]>(url);
  }
}



// WEBPACK FOOTER //
// ./src/app/core/services/division.service.ts